import React from 'react';

import { ButtonWithIcon } from '@/components';
import { CallIcon } from '@/components/Icons';

import { R } from '@/caregiverSpace/resources/Texts.resx';

type PhoneCallButtonProps = {
    onClick: (event: React.MouseEvent<HTMLElement>) => void;
    disabled: boolean;
    isLoading: boolean;
    className?: string;
};

export const PhoneCallButton = ({
    disabled,
    isLoading,
    ...props
}: PhoneCallButtonProps) => {
    return (
        <ButtonWithIcon
            icon={<CallIcon />}
            variant="primary"
            disabled={disabled || isLoading}
            {...props}
        >
            {R.ButtonCallPhone}
        </ButtonWithIcon>
    );
};
